export const checkRouteAccess = (route, fallback = true) => {
  const {canAccess} = route;
  if (typeof canAccess === 'boolean') {
    return canAccess;
  }
  if (typeof canAccess === 'function') {
    return canAccess();
  }
  return fallback;
};
